import React from 'react'
import PropTypes from 'prop-types'
import { parse, format } from 'date-fns'

import { join, map } from 'lodash'

import { translate, utils } from 'parking-react-common'

import Panel from '../components/Panel'
import Table from '../components/Table'

const SpecialIntervalsList = (props) => {
    const { item, t } = props

    const columns = [
        {
            key    : 'date',
            title  : t('Date Interval'),
            render : ({ cellData }) => join(map(cellData, utils.formatPrettyDate), ' - ')
        },
        {
            key   : 'startTime',
            title : t('From'),
            parse : ({ cellData }) => format(parse(cellData, 'HH:mm:ss', new Date()), 'HH:mm')
        },
        {
            key   : 'stopTime',
            title : t('To'),
            parse : ({ cellData }) => format(parse(cellData, 'HH:mm:ss', new Date()), 'HH:mm')
        },
        {
            key    : 'price',
            title  : t('Price'),
            render : ({ cellData }) => utils.formatAmountWithUnit(cellData, item.currency)
        }
    ]

    return (
        <Panel
            title={ t('Special Intervals / Holidays') }
            hasTable
        >
            <Table
                columns={ columns }
                data={ item.specialIntervals }
            />
        </Panel>
    )
}

SpecialIntervalsList.propTypes = {
    item: PropTypes.object.isRequired
}

export default translate()(SpecialIntervalsList)
